<template>
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M198.13 237.86C206.07 237.86 213.54 234.77 219.16 229.15C222.28 226.03 222.28 220.96 219.16
      217.84C216.04 214.72
      210.97 214.72 207.85 217.84C205.26 220.43 201.81 221.86 198.14 221.86C194.47 221.86 191.02
      220.43 188.43 217.84C185.31
      214.72 180.24 214.72 177.12 217.84C174 220.96 174 226.03 177.12 229.15C182.74 234.77 190.2
      237.86 198.15 237.86H198.13Z"
      fill="currentColor"
    />
    <path
      d="M477.62 280.57C472.74 274.08 465.34 271.99 456.61 271.34L445.23 271.5V226.5C445.23 222.56 442.02 219.35 438.08
      219.35H323.19C318.9 203.77 315.18 188.01 315.18 163.56C315.18 110.97 306.28 72.33 287.97 45.43C268.46 16.79 238.25
      2.26 198.13 2.26C158.01 2.26 127.8 16.78 108.3 45.42C89.99 72.32 81.09 110.96 81.09 163.55
      C81.09 190.78 76.48 207.24
      71.6 224.66C65.9 245.01 60.02 266.03 62.33 303.59C43.8 316.73 28.64 352.08 16.11 411.32C6.43
      457.07 2.09 500.77 2.05
      501.21C1.62 505.61 4.83 509.52 9.23 509.95C9.5 509.98 9.76 509.99 10.02 509.99C14.09 509.99
      17.57 506.9 17.97 502.77C18.01
      502.34 22.27 459.52 31.76 414.63C47.93 338.17 65.27 319.43 74.16 315.07C83.73 310.38 97.59
      305.45 113.65 299.74C116.72
      298.65 119.9 297.52 123.13 296.36C124.45 299.29 125.73 302.24 126.98 305.14C132.84 318.7
      138.89 332.73 149.24 343.31C161.16
      355.51 177.15 361.43 198.13 361.43C219.11 361.43 235.1 355.5 247.02 343.31C257.37 332.72
      263.42 318.7 269.28 305.14C269.36
      304.95 269.43 304.66 269.5 304.29V442.24C269.5 457.18 280.7 469.63 295.54 471.2L306.35
      471.24C306.17 472.25 306.17 473.3
      306.39 474.34L312.74 503.95C313.55 507.7 316.86 510.27 320.55 510.27C321.11 510.27 321.67
      510.21 322.24 510.09C326.56
      509.16 329.31 504.91 328.38 500.59L324.34 481.77C337.2 494.24 350.84 500.74 364.42 500.74
      C364.7 500.74 364.98 500.74 365.26
      500.73C381.03 500.42 395.67 491.34 407.62 474.48L409.58 471.36H438.07C442.01 471.36 445.22
      468.15 445.22 464.21V426.4L452.67
      410.32C464.78 390.24 475.19 368.09 480.09 343.95C482.6 337.06 483.74 327.95 483.74 316.26
      C483.74 299.63 483.31 288.16 477.61
      280.59L477.62 280.57ZM121.53 54.43C138.1 30.09 163.15 18.26 198.13 18.26C233.11 18.26 258.17
      30.09 274.73 54.43C287.23
      72.8 294.98 98.84 297.87 132.07C291.94 128.29 285.06 126.25 277.86 126.25C183.57 126.25 163.95
      108.44 161.78 106.09C160.51
      102.56 157.11 100.92 153.34 101.47C149.45 102.04 146.79 105.93 146.73 109.85C146.73 110.01
      146.17 126.24 118.39 126.24C111.19
      126.24 104.31 128.28 98.38 132.06C101.27 98.83 109.02 72.79 121.52 54.42L121.53 54.43ZM299.17
      163.56C299.17 172.48 293.66
      180.14 285.87 183.3V143.8C288.48 144.86 290.88 146.44 292.93 148.49C296.95 152.51 299.17 157.86
      299.17 163.55V163.56ZM269.87
      142.21V182.71C269.87 222.27 237.69 254.45 198.13 254.45C158.57 254.45 126.39 222.27 126.39
      182.71V141.85C144.17 139.98
      153.92 131.9 158.73 123.63C172.69 131.73 203.29 141.48 269.87 142.21ZM103.33 148.49C105.38
      146.44 107.78 144.85 110.39
      143.8V183.3C102.6 180.13 97.09 172.47 97.09 163.56C97.09 157.87 99.31 152.52 103.33 148.5
      V148.49ZM124.57 278.83C124.57 278.83
      124.5 278.86 124.46 278.87C118.9 280.9 113.46 282.83 108.29 284.67C96.94 288.71 86.66 292.36
      77.97 295.91C76.85 265.28 81.8
      247.58 87.01 228.98C90.09 217.97 93.24 206.73 95.18 192.72C100.01 196.58 105.82 199.26 112.17
      200.33C117.26 225.21 132.92
      246.29 154.24 258.66V265.3C154.24 266.81 152.94 267.88 151.73 268.39C142.73 272.11 133.49 275.6
      124.58 278.84L124.57 278.83ZM254.59
      298.8C243.34 324.86 234.45 345.44 198.13 345.44C161.81 345.44 152.92 324.86 141.67 298.8C140.54
      296.19 139.39 293.53 138.2
      290.85C144.71 288.41 151.31 285.86 157.83 283.16C165.17 280.13 169.96 273.39 170.21 265.89
      C178.98 268.84 188.37 270.45 198.13
      270.45C207.89 270.45 217.28 268.85 226.05 265.89C226.3 273.39 231.09 280.13 238.43 283.16
      C244.98 285.87 251.52 288.53 257.95
      291.11C256.8 293.7 255.69 296.27 254.59 298.8ZM269.5 249.86V279.19C269.4 278.67 269.29 278.37
      269.17 278.37C261.12 275.17 252.84
      271.81 244.54 268.38C243.33 267.88 242.03 266.8 242.03 265.29V258.65C263.34 246.28 279 225.21
      284.09 200.33C290.44 199.26 296.25
      196.58 301.08 192.72C302.32 201.7 304.07 209.55 305.97 216.93C306.18 217.75 306.4 218.54
      306.62 219.35H300.01C283.19 219.35 269.5
      233.04 269.5 249.86ZM292.85 235.33V413.69C289.64 414.33 286.59 415.51 283.8 417.17V249.86C283.8
      243.64 287.44 238.02 292.85
      235.33ZM364.95 484.72C364.77 484.72 364.6 484.72 364.43 484.72C355.44 484.72 345.99 480.13
      336.61 471.33H340.06H389.71C383.56
      478.21 375.18 484.5 364.96 484.7L364.95 484.72ZM413.01 457.05H340.07L296.11 456.84C289.08
      455.63 283.81 449.4 283.81 442.24C283.81
      434.07 290.46 427.42 298.63 427.42H413.02C410.38 431.87 408.96 436.97 408.96 442.24C408.96
      447.51 410.37 452.6 413.02 457.06L413.01
      457.05ZM430.92 455.22C426.27 452.67 423.26 447.76 423.26 442.24C423.26 436.72 426.27 431.81
      430.92 429.26V455.22ZM430.92 413.12H307.16
      V233.66H430.92V413.12ZM445.22 391.09V361.12C447.37 361.33 449.72 361.44 452.32 361.44C454.61
      361.44 456.75 361.3 458.77 361.04C455.12
      371.44 450.46 381.46 445.23 391.09H445.22ZM465.04 338.54C465.02 338.59 465 338.65 464.97 338.7C464.42
      340.11 463.8 341.28 463.09
      342.18C461.52 344.19 459.17 345.43 452.31 345.43C450.68 345.43 447.51 345.46 445.21 345.43V287.49
      C455.05 287.58 463.29 288.16 464.82
      290.19C467.51 293.77 467.73 305.02 467.73 316.25C467.73 326.35 466.82 333.81 465.03 338.55L465.04 338.54Z"
      fill="currentColor"
    />
    <path
      d="M89.24 378.72C88.21 379.56 63.89 399.72 61.81 428.67C60.22 450.87 69.11 467.59 73.49 474.37L67.87 500.58C66.94
      504.9 69.69 509.15 74.02 510.08C74.59 510.2 75.15 510.26 75.71 510.26C79.4 510.26 82.72 507.69 83.52 503.94L89.87
      474.33C90.37 472 89.78 469.54 88.31 467.67C88.19 467.52 76.19 451.99 77.78 429.81C79.35 407.93 99.03 391.39 99.37
      391.1C102.78 388.3 103.29 383.27 100.5 379.85C97.71 376.43 92.67 375.91 89.24 378.71V378.72Z"
      fill="currentColor"
    />
    <path
      d="M334.55 315.8H398.94C407.46 315.8 414.4 308.87 414.4 300.34V268.67C414.4 260.15 407.47 253.21 398.94 253.21
      H334.55C326.03 253.21 319.09 260.14 319.09 268.67V300.34C319.09 308.86 326.02 315.8 334.55 315.8ZM333.4
      268.67C333.4 268.03 333.92 267.52 334.55 267.52H398.94C399.58 267.52 400.09 268.04 400.09 268.67V300.34
      C400.09 300.98 399.57 301.49 398.94 301.49H334.55C333.91 301.49 333.4
      300.97 333.4 300.34V268.67Z"
      fill="currentColor"
    />
  </svg>
</template>
